import React from 'react';
import { Modal, Descriptions } from 'antd';
import moment from 'moment';
import '../CustomerPopupModal.css'; // Import the custom CSS file

const CustomerPopupModal = ({ open, hideModal, user_info, user_id }) => {

  // Filtering user info based on user_id
  const filteredUserInfo = user_info?.filter(user => user._id === user_id);
 

  return (
    <Modal
      title="User Information"
      centered
      open={open}
      onOk={hideModal}
      onCancel={hideModal}
      footer={null} // Remove default footer buttons
      width={800}
      className="custom-modal"
    >
      {filteredUserInfo && filteredUserInfo.length > 0 ? (
        <Descriptions
          bordered
          column={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 1, xs: 1 }} // Adjust column layout based on screen size
          layout="horizontal" // Use vertical layout for better readability
        >
          <Descriptions.Item label="Person Name">{filteredUserInfo[0].name}</Descriptions.Item>
          <Descriptions.Item label="Unique ID">{filteredUserInfo[0].unique_id}</Descriptions.Item>
          <Descriptions.Item label="Email">{filteredUserInfo[0].email}</Descriptions.Item>
          <Descriptions.Item label="Phone No">{filteredUserInfo[0].phone_no}</Descriptions.Item>
          <Descriptions.Item label="Qualification">{filteredUserInfo[0].qualification}</Descriptions.Item>
          <Descriptions.Item label="Experience">{filteredUserInfo[0].experience}</Descriptions.Item>
          <Descriptions.Item label="Skill Area">{filteredUserInfo[0].skill_area}</Descriptions.Item>
          <Descriptions.Item label="State">{filteredUserInfo[0].state}</Descriptions.Item>
          <Descriptions.Item label="District">{filteredUserInfo[0].district}</Descriptions.Item>
          <Descriptions.Item label="Cluster Name">{filteredUserInfo[0].cluster_name || 'N/A'}</Descriptions.Item>
          <Descriptions.Item label="School UDISE Code">{filteredUserInfo[0].schoolId}</Descriptions.Item>
          <Descriptions.Item label="Address">{filteredUserInfo[0].address}</Descriptions.Item>
          <Descriptions.Item label="Role">{filteredUserInfo[0].role === 'vc' ? 'Vocational Co-ordinator' : 'Voactional Trainner'}</Descriptions.Item>
          <Descriptions.Item label="Is Blocked">{filteredUserInfo[0].isBlocked ? 'Yes' : 'No'}</Descriptions.Item>
          <Descriptions.Item label="Created At">{moment(filteredUserInfo[0].createdAt.$date).format('YYYY-MM-DD HH:mm:ss')}</Descriptions.Item>
          <Descriptions.Item label="Latitude">{filteredUserInfo[0].lat}</Descriptions.Item>
          <Descriptions.Item label="Longitude">{filteredUserInfo[0].long}</Descriptions.Item>
          <Descriptions.Item label="Profile Complete">{filteredUserInfo[0].profile_complete ? 'Yes' : 'No'}</Descriptions.Item>
          <Descriptions.Item label="Profile Image">
        <img 
        src={filteredUserInfo && filteredUserInfo[0].images[0] ? filteredUserInfo[0].images[0].url  : "https://i.pinimg.com/originals/0d/64/98/0d64989794b1a4c9d89bff571d3d5842.jpg"} 
        alt="Profile" 
        style={{ width: '100px', height: '100px' }} 
      />
      
          </Descriptions.Item>
        </Descriptions>
      ) : (
        <p>No User Data Available for this ID.</p>
      )}
    </Modal>
  );
};

export default CustomerPopupModal;
